// extracted by mini-css-extract-plugin
module.exports = {"row":"CardsRow_row__STF8O"};